import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { graphql } from "react-apollo"
import { useShowSuccessToast } from "gatsby-interface"
import { useGenericError } from "@modules/modal"
import { CheckoutForm, PaymentProvider } from "@modules/payment"
import { paymentInformation as text } from "@modules/locales/default.json"
import { UPDATE_PAYMENT_INFO } from "@modules/payment/queries"

let CheckoutFormWithMutation = CheckoutForm

if (graphql) {
  CheckoutFormWithMutation = graphql(UPDATE_PAYMENT_INFO)(
    CheckoutFormWithMutation
  )
}

export function UpdatePaymentForm({
  organizationId,
  id,
  setResponse,
  cancelCallback,
  className,
}) {
  const showSuccessToast = useShowSuccessToast()
  const throwError = useGenericError()

  return (
    <Fragment>
      <PaymentProvider>
        <CheckoutFormWithMutation
          checkoutType="UPDATE_PAYMENT"
          cancelCallback={cancelCallback}
          submitButtonText={text.updatePayment}
          cancelButtonText={text.cancelText}
          planId={id}
          organizationId={organizationId}
          className={className}
          showSuccess={creditCard => {
            setResponse({
              success: true,
              creditCard,
            })
            showSuccessToast(
              <React.Fragment>
                <strong>{text.paymentInformation}</strong>
                {` `}
                {text.updatedSuccessfully}
              </React.Fragment>
            )
            cancelCallback()
          }}
          showError={err => throwError({ message: err, className: `fs-block` })}
        />
      </PaymentProvider>
    </Fragment>
  )
}

UpdatePaymentForm.propTypes = {
  name: PropTypes.string,
  organizationId: PropTypes.string,
  planId: PropTypes.string,
  setMessage: PropTypes.func,
  cancelCallback: PropTypes.func,
}
